import {
  Checkbox,
  FormControlLabel,
  FormControl,
  FormHelperText,
  FormControlLabelProps,
} from '@mui/material';
import React, { ReactNode } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { styles } from '~/components/FormComponents/styles.ts';

interface IFormCheckboxProps {
  name: string;
  label: ReactNode;
  onChange?: (isChecked: boolean) => void;
  disableFieldOnChange?: boolean;
  disabled?: boolean;
  formControlLabelProps?: Omit<FormControlLabelProps, 'control' | 'label'> & {
    'data-testid'?: string;
  };
  fullWidth?: boolean;
}

export const FormCheckbox = ({
  name,
  label,
  disableFieldOnChange,
  onChange,
  disabled,
  formControlLabelProps,
  fullWidth,
}: IFormCheckboxProps) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const error = errors?.[name as keyof typeof errors];

  return (
    <FormControl error={!!error} sx={{ width: fullWidth ? '100%' : 'initial' }}>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <FormControlLabel
            {...formControlLabelProps}
            label={label}
            data-testid={`${name}-form-control-label`}
            control={
              <Checkbox
                checked={!!field.value}
                disabled={disabled}
                onChange={(e) => {
                  !disableFieldOnChange && field.onChange(e.target.checked);
                  onChange?.(e.target.checked);
                }}
                sx={styles.disabledCheckbox}
                slotProps={{
                  input: {
                    'data-testid': `${name}-checkbox`,
                  } as React.InputHTMLAttributes<HTMLInputElement>,
                }}
              />
            }
          />
        )}
      />
      <FormHelperText>{(error as { message?: string })?.message}</FormHelperText>
    </FormControl>
  );
};
